import { Action, createReducer, on } from '@ngrx/store';
import { initializeSecureFlightInfoState, reAddSfiForRoutedReservationComplete } from './secure-flight-info.actions';
import { initialSecureFlightInfoState } from './secure-flight-info.state';

const featureReducer = createReducer(
  initialSecureFlightInfoState,
  /**
   * Reinitialize the secure flight info state
   */
  on(initializeSecureFlightInfoState, (state) => ({ ...state, ...initialSecureFlightInfoState })),
  on(reAddSfiForRoutedReservationComplete, (state, { response, status }) => {
    return { ...state, reAddSfiResponse: response, reAddSfiStatus: status };
  })
);

export function secureFlightInfoReducer(state = initialSecureFlightInfoState, action: Action) {
  return featureReducer(state, action);
}
